import { useMemo } from 'react';
import { cn, PaletteUtils } from '@shared/utils';
import styles from './styles.module.css';

const OrientationTypeEnum = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
} as const;
type OrientationTypeEnum = (typeof OrientationTypeEnum)[keyof typeof OrientationTypeEnum];
type OrientationType = OrientationTypeEnum | `${OrientationTypeEnum}`;

interface RadioProps<T> {
  className?: string;
  orientation: OrientationType;
  options?: { text: string; value: T }[];
  readonly?: boolean;
  value?: T | string;
  onChange?: (val: T) => void;
}

export const Radio = <T,>(props: RadioProps<T>) => {
  const isVertical = useMemo(() => props.orientation === OrientationTypeEnum.Vertical, [props.orientation]);

  return (
    <div className={cn('flex w-full border-none p-0', isVertical ? 'flex-col gap-1' : 'flex-row gap-5', props.className)}>
      {props.options?.map((item, key) => (
        <div
          key={key}
          className={cn(
            'flex cursor-pointer items-center rounded-bl-md rounded-tl-md p-2 pr-0 dark:bg-soft-black',
            isVertical && 'rounded border border-black dark:border-gray-white',
            props.readonly && 'border-gray-400',
            styles.item,
          )}
          onClick={() => !props.readonly && props.onChange?.(item.value)}
        >
          <input
            className={cn(styles.radio, PaletteUtils.isVcfcPalette && styles.vcfc, PaletteUtils.isPersonalPalette && styles.personal)}
            type='radio'
            readOnly={props.readonly}
            checked={item.value === props.value}
          />
          <label className={cn(props.readonly && 'text-gray-400')}>{item.text}</label>
        </div>
      ))}
    </div>
  );
};
